var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":_vm.capitalizeFirstLetter(_vm.schema.title),"message":_vm.schema.description}},[_c('b-input',{attrs:{"type":"textarea","minlength":_vm.schema.minLength,"maxlength":_vm.schema.maxLength,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }